module.exports = __webpack_public_path__ + "media/images/colorpicker/saturation-29d4d119f001bfe76e664313bdddc31f.png";